import { Component, Input } from '@angular/core';

/**
 * Aviso de solo lectura para los paneles alcanzados por el candado de edición.
 * Se pinta arriba del panel cuando el operador no está autorizado a escribir.
 *
 * Ver `AdminEditPermissionsService`.
 */
@Component({
  selector: 'app-solo-lectura-banner',
  template: `
    <div
      style="background: #fffbeb; border: 1px solid #fde68a; border-radius: 12px; padding: 12px 16px; margin-bottom: 16px; display: flex; align-items: flex-start; gap: 8px;">
      <mat-icon
        style="font-size: 18px; width: 18px; height: 18px; color: #f59e0b; flex-shrink: 0; margin-top: 1px;">lock</mat-icon>
      <span style="font-size: 0.8rem; color: #92400e; line-height: 1.4;">
        <strong>Solo lectura.</strong> {{ detalle }}
      </span>
    </div>
  `,
})
export class SoloLecturaBannerComponent {
  /** Qué queda bloqueado en este panel, en una frase. */
  @Input() detalle =
    'Esta configuración está reservada al operador autorizado.';
}
